import { writeGladlySessionCookie } from "./bridge";
import { getAppId, getEnv } from "./config";
export function loadGladly() {
    return new Promise((resolve, reject) => {
        var _a;
        // If the SDK is already present, prevent loading.
        if ((_a = window.Gladly) === null || _a === void 0 ? void 0 : _a.init) {
            resolve(window.Gladly);
            return;
        }
        window.gladlyConfig = { appId: getAppId() };
        /* --------------  DOCS SNIPPET -------------- */
        // Gladly loader (verbatim from docs)
        /* eslint-disable */
        // @ts-ignore
        !(function (c, n, r, t) {
            var _a;
            if (!c[r]) {
                let i, d, q = [];
                d =
                    "PROD" !== t && t
                        ? "STAGING" === t
                            ? "https://cdn.gladly.qa/gladly/chat-sdk/widget.js"
                            : t
                        : "https://cdn.gladly.com/chat-sdk/widget.js";
                c[r] = {
                    init() {
                        i = arguments;
                        const p = {
                            then: (fn) => (q.push({ type: "t", next: fn }), p),
                            catch: (fn) => (q.push({ type: "c", next: fn }), p),
                        };
                        return p;
                    },
                };
                c.__onHelpAppHostReady__ = function (sdk) {
                    delete c.__onHelpAppHostReady__;
                    (c[r] = sdk).loaderCdn = d;
                    if (i) {
                        let e = sdk.init.apply(sdk, i);
                        q.forEach(({ type, next }) => (e = type === "t" ? e.then(next) : e.catch(next)));
                    }
                    resolve(sdk);
                };
                try {
                    const s0 = n.getElementsByTagName("script")[0];
                    const s = n.createElement("script");
                    s.async = true;
                    s.src = d + "?q=" + Date.now();
                    s.onerror = reject;
                    (_a = s0.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(s, s0);
                }
                catch (err) {
                    reject(err);
                }
            }
        })(window, document, "Gladly", getEnv());
        /* ========================================= */
    });
}
export const exposeGladlyHandler = () => {
    window.showGladlyChat = async () => {
        var _a;
        const btn = document.querySelector("#designstudio-button > button");
        btn === null || btn === void 0 ? void 0 : btn.removeAttribute("id");
        btn === null || btn === void 0 ? void 0 : btn.setAttribute("id", "custom-gladly-chat-button");
        const sdk = await loadGladly();
        (_a = sdk.show) === null || _a === void 0 ? void 0 : _a.call(sdk);
    };
    window.addEventListener("beforeunload", () => {
        writeGladlySessionCookie();
    });
};
